import { useAppSelector } from "../../../../hooks";
import { isChatOpen, useControlContext } from "../../../control";
import { selectChatSettings } from "../../selectors";
import type { ChatChildren } from "../../types";

type Props = {
  dataTestId?: string;
  className: string;
  children: ChatChildren;
};

export const ChatButton = ({
  dataTestId = "chat-icon-button",
  className,
  children,
}: Props) => {
  const { chatState, handleChatOpen } = useControlContext();
  const { unreadCount } = useAppSelector(selectChatSettings);

  const params = {
    isChatOpen: isChatOpen(chatState),
    unreadMessages: unreadCount,
    handleButtonClick: handleChatOpen,
  };

  return (
    <div data-test-id={dataTestId} className={className}>
      {children(params)}
    </div>
  );
};
